export default (props, vars) => ({ __html: props?.['innerHTML'] });
